import { createApi } from '@reduxjs/toolkit/query/react';
import type { sessionData } from '../userSessionContextParser';
import { createBaseQuery } from '../baseApi';

export const plantApi = createApi({
    reducerPath: 'plantApi',
    baseQuery: createBaseQuery('plants/'),
    tagTypes: ['PLANTDETAILS'],
    endpoints: (builder) => ({
        createPlant: builder.mutation<sessionData, any>({
            query(data) {
                return {
                    url: 'create',
                    method: 'post',
                    body: data,
                };
            },
            invalidatesTags: ['PLANTDETAILS'],
        }),

        updatePlant: builder.mutation<any, { ID: any; formData: any }>({
            query: ({ ID, formData }) => ({
                url: `/update/${ID}`,
                method: 'PUT',
                body: formData,
            }),
            invalidatesTags: ['PLANTDETAILS'],
        }),
        deletePlant: builder.mutation<any, any>({
            query: (ID) => ({
                url: `/delete/${ID}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['PLANTDETAILS'],
        }),

        getPlantById: builder.query({
            query: (id) => `/${id}`,
            providesTags: ['PLANTDETAILS'],
        }),

        getAllPlantsDetails: builder.query({
            query: (params: any) => ({
                url: '/all',
                params: {
                    page: params.pageNum || 1,
                    limit: 20,
                    search: params.search || ''
                }
            }),

            providesTags: ['PLANTDETAILS'],


        }),

    }),
});

export const { useCreatePlantMutation, useLazyGetAllPlantsDetailsQuery, useGetPlantByIdQuery, useUpdatePlantMutation,useDeletePlantMutation } = plantApi;